<template>
    <div class="inspection-wrapper">

 
    <div class="devicemanage_class_1">
        
        <div class="seachtitle ">
            <el-form :inline="true" :model="formInline" label-position="left" class="tableform">
              
                <el-form-item label="用户名称：">
                    <el-input size="default" v-model.trim="formInline.name" maxlength="30" placeholder="请输入设备名称"
                        clearable style="width:200px"></el-input>
                </el-form-item>
             
                <el-form-item label="所属部门：">
                    <el-select v-model="formInline.department" placeholder="请选择" size="default" clearable
                        style="width:160px;">
                        <el-option v-for="item in factoryGroupList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号：">
                    <el-input size="default" v-model.trim="formInline.phone" maxlength="30" placeholder="请输入设备名称"
                    clearable style="width:160px"></el-input>
                </el-form-item>
                
              
                <el-form-item>
                    <el-button @click="search" type="primary" icon="Search" style="margin-left: 20px;">查询</el-button>
                    <el-button @click="handleEdit('','reset')" icon="Refresh" style="margin-left: 20px;">重置</el-button>
                    <el-button @click="addDevicefun"  type="primary" icon="Plus" style="margin-left: 100px;">添加用户</el-button>
                </el-form-item>
               

            </el-form>
        </div>
        <div class="ops_content">
            <el-table  border :data="tableData" ref="tableref"
                v-loading="loadingPage" style="width: 100%;">
                <el-table-column type="index" width="60" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" prop="name" label="用户名称" show-overflow-tooltip
                    align="center"></el-table-column>
                <el-table-column min-width="100" prop="phone_number" label="手机号" show-overflow-tooltip
                    align="center"></el-table-column>
                <el-table-column min-width="100" prop="depart" label="所属部门" show-overflow-tooltip
                    align="center"></el-table-column>
                <el-table-column min-width="100" prop="role" label="用户类型" show-overflow-tooltip
                align="center"></el-table-column>
                <el-table-column min-width="100" prop="enable" label="状态" show-overflow-tooltip
                    align="center"></el-table-column>
                <el-table-column min-width="100" prop="create_time" label="添加时间" show-overflow-tooltip
                    align="center"></el-table-column>
                <el-table-column label="操作"  min-width="100" align="center">
                    <template #default="{row}">
                     
                        <el-button   type="danger"    @click="handleEdit(row.id,'delete')">删除</el-button>
                        <el-button   type="primary"   @click="handleEdit(row.id,'Edit')">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather" ></Pagination>
        </div>
      
    </div>
   
    
    <addUser ref="addDeviceFlag" @refreshData="refreshAllData"></addUser>
   
  </div>
 
  
 
</template>


<script>
import {apiWxuser,apiDeleteWxuser} from '@/api/api'
import Pagination from "@/components/Pagination";

import {ElMessageBox } from 'element-plus'

import addUser from "./components/addUser";


 export default{
    name:'userManage',
    emits: ['handleInfo'],
    components:{
            Pagination,
            addUser,
        },
    data(){
        return{
         
          
            tableHeight:500,
          
            loadingPage:false,
            showOtherSearch:false,//隐藏过长的搜索条件
            formInline:{
                    name: null,
                    department: null,
                    phone:null,
                 
            },
          
            tableData:[],
       
            factoryGroupList:[
                    {id:0,name:'全部'},
                    {id:1,name:'宜化公司'},
                    {id:2,name:'设备管理部'},
                    {id:3,name:'维修分厂'},
                    {id:4,name:'电仪部'},
                    {id:5,name:'PVC分厂'},
                    {id:7,name:'电石分厂'},
                    {id:8,name:'原料分厂'},
                    {id:9,name:'烧碱分厂'},
                    {id:10,name:'合成分厂'},
                    {id:11,name:'乙炔分厂'},
            ],  
          
            pageparm: {
                    page: 1,
                    page_size: 10,
                    total:1
                },
            fnParm:{
                page: 1,
                page_size: 10,  
            
                ordering:"processed,-time",         
            },
            fntableParm:{
                    page: 1,
                    page_size: 10,
                    ordering:"processed,-time",   
                    depart_exact: null,
                    name : null,
                    phone_number:null
                    
                },
           
    }
    },
    methods:{
          // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.page_size + $index +1
            },
       
            handleEdit(id,flag) {
              
                if(flag=='delete') {
                    ElMessageBox.confirm('您确定要删除选中的数据吗？',
                     '警告',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(res=>{
                          
                        apiDeleteWxuser({id}).then(res =>{
                        
                            this.$message.success("删除用户成功")
                            this.search()
                           
                        }).catch( ()=>{
                            this.$message.warning("删除用户失败")
                        })
                    }).catch(()=>{
                        this.$message.warning("删除用户失败")
                    })
                }
                else if(flag=="reset"){
                  
                    
                    this.fntableParm = {
                        page:1,
                        page_size: 10,
                        ordering: "-device__status,device__name",
                    }
                    this.pageparm={
                        page: 1,
                        page_size: 10,
                        total: 0
                    }
                 
                    this.formInline.name = null
                    this.formInline.department = null
                    this.formInline.phone = null
                    this.getData()
                }else if(flag == 'Edit'){
                    apiWxuser({id}).then(res =>{
                        if(res.data.code ==200){
                         
                            
                            this.$refs.addDeviceFlag.addDeviceFn(res.data.data,'添加用户信息')
                        }
                    })
                   
                }
            },
            callFather(parm) {
              
                this.fntableParm.page = parm.page
                this.fntableParm.page_size = parm.page_size
              
                this.fntableParm.ordering = "processed,-time",
                this.getData()
            },
          
            addDevicefun(){
                
              
                this.$refs.addDeviceFlag.addDeviceFn(null,'添加用户信息')
            },
          
            
            refreshAllData(){
                this.search()
                this.getData()
            },
            handleInfo(flag){
               
                
               if(flag =='quit'){
            
                this.getData()
               }
              
            },

            search() {
             
             
                this.pageparm.page = 1
                this.fntableParm.page = this.pageparm.page
                this.fntableParm.page_size = this.pageparm.page_size
                this.fntableParm.name = this.formInline.name
                this.fntableParm.phone_number = this.formInline.phone
               
              
                 
                if(this.formInline.department == null || this.formInline.department == 0){

                    this.fntableParm.depart = null
                } 
                else{
                     
                    this.fntableParm.depart_exact= this.formInline.department
                 
                } 
                   
                    
                   this.fntableParm.ordering = "processed,-time",
              
            
                this.getData()
            },

            dataChange(items){
                this.tableData.length = 0
                for(let i = 0;i<items.length;i++){
                    this.tableData[i] = items[i]
                    switch(items[i].depart){
                        case "1":  this.tableData[i].depart= "宜化公司";break;
                        case "2":  this.tableData[i].depart= "设备管理部";break;
                        case "3": this.tableData[i].depart= "维修分厂" ;break;
                        case "4":  this.tableData[i].depart= "电仪部";break;
                        case "5":  this.tableData[i].depart= "PCV分厂";break;
                        case "6": this.tableData[i].depart= "电石分厂" ;break;
                        case "7":  this.tableData[i].depart= "原料分厂";break;
                        case "8":  this.tableData[i].depart= "烧碱分厂";break;
                        case "9": this.tableData[i].depart= "合成分厂" ;break;
                        case "10":  this.tableData[i].depart= "乙炔分厂";break;
                       
                     
                    }
                    switch(items[i].role){
                        case 1:  this.tableData[i].role="管理员" ;break;
                        case 2:  this.tableData[i].role="用户" ;break;
                     
                        default: this.tableData[i].role="未知" ;break;
                    } 
                    switch(items[i].enable){
                        case true:  this.tableData[i].enable="启用" ;break;
                        case false:  this.tableData[i].enable="未启用" ;break;
                     
                        default: this.tableData[i].enable="未知" ;break;
                    }                    
                   
                }       
            },


            getData(){
                this.loadingPage = true
                this.tableData.length = 0;
               
                
                apiWxuser(this.fntableParm).then(res => {
                    this.loadingPage = false
                    if(res.data.code ==200) {
                        this.dataChange(res.data.data.items)
                        this.pageparm.total = res.data.data.total;
                        let { page, page_size } = res.config.params 
                        this.pageparm.page = page    
                        this.pageparm.page_size = page_size  
                    }else{
                        this.$message.error(res.data.msg)
                    }
                 }) .catch(res => {  
                    this.loadingPage = false
                    this.$message.warning(`获取传感器信息失败 : ${res.msg}`)
                }); 
            },
            
           
          
         
            
    },
    created(){
        
     
        
        this.getData()
 

    }
 }


</script>
<style lang="scss" scoped>
.inspection-wrapper{
    height: calc(100vh * 0.82);
 
    .devicemanage_class_1{

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: url("@/assets/bigscreen/block_bg.jpg") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    padding: 20px;
    height: 100%;
  
    .seachtitle{
        width: 100%;
        .tableform{
            padding: 0px;
        }
    }
    .ops_content{
        width: 100%;
        height: 100%;
      
        // margin: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: auto;
       
      
    
    }
   
    }
   
}




</style> 